import { Components, Theme } from '@mui/material/styles';

export const tabsConfigs: Components<Theme>['MuiTabs'] = {
  styleOverrides: {
    root: ({ theme }) => ({
      minHeight: 0,
      position: 'relative',
      marginBottom: theme.spacing(3),

      '::before': {
        content: '""',
        height: 1,
        width: '100%',
        backgroundColor: theme.palette.grey[300],
        position: 'absolute',
        bottom: 0,
      },

      '& .MuiTabs-indicator': {
        backgroundColor: theme.palette.secondaryPink[500],
        height: 4,
      },
    }),
  },
};
